import { vendorService } from '../../../services';

/**
 * Per-page analytics for vendor pages (README §11). Events are batched and flushed on a short
 * timer or on page hide. Logged-out viewers get a per-device anonymous id so uniques can be
 * counted without an account. Nothing here is a session, a DAU or time-on-page — by spec.
 */
const ANON_KEY = 'pr.anon';
export function anonymousId() {
  try {
    let v = localStorage.getItem(ANON_KEY);
    if (!v) { v = `a-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`; localStorage.setItem(ANON_KEY, v); }
    return v;
  } catch { return null; }
}
const device = () => (typeof window !== 'undefined' && window.innerWidth < 640 ? 'phone' : 'desktop');
const region = () => { try { const raw = localStorage.getItem('pr.userLocation'); const v = raw ? JSON.parse(raw) : null; return v?.label && v.label !== 'Your location' ? v.label : null; } catch { return null; } };

export function makeTracker(slug) {
  let queue = [];
  let timer = null;
  const flush = () => {
    if (queue.length === 0) return;
    const batch = queue; queue = [];
    vendorService.track(slug, batch).catch?.(() => {});
  };
  const track = (type, props = {}, extra = {}) => {
    if (!slug) return;
    queue.push({ type, props: Object.keys(props).length ? JSON.stringify(props) : null, anonymousId: anonymousId(), device: device(), region: region(), ...extra });
    if (queue.length >= 8) flush();
    else { clearTimeout(timer); timer = setTimeout(flush, 1500); }
  };
  if (typeof document !== 'undefined') document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flush(); });
  return { track, flush };
}
